/* eslint max-len:0 */
angular.module('qkr').controller('formsController', ['$scope', 'formBuilderService',
    'beneficiariesService', 'messageService',
    function($scope, formBuilderService, beneficiariesService, messageService) {
        const vm = this;
        vm.activeTab = 0;

        const loadTemplates = function() {
            formBuilderService.listTemplates().then((response) => {
                vm.templates = response.data;
            });
        };

        const loadForms = function() {
            formBuilderService.listForms().then((response) => {
                vm.forms = response.data;
                if (vm.forms.length > 0) {
                    // if there is form linked to the menuItem display the second tab
                    vm.activeTab = 1;
                }
            });
        };

        const loadCustomFields = function() {
            beneficiariesService.loadBeneficiaryCustomFields().then(
                (response) => {
                    const listDefinitions = response;

                    vm.arrCustomFields = ['Surname'];

                    angular.forEach(listDefinitions, (beneficiaryCF) => {
                        if (beneficiaryCF.type === 'DROPDOWN') {
                            vm.arrCustomFields.push(beneficiaryCF.fieldName);
                        }
                    });
                },
                (reason) => {
                    messageService.error(reason);
                }
            );
        };

        const init = function() {
            loadForms();
            loadCustomFields();
            loadTemplates();

            vm.setArrow('prodGroupName', vm.reverse);
        };

        $scope.$on('reloadTemplates', () => {
            loadTemplates();
        });

        $scope.$on('reloadForms', () => {
            loadForms();
        });

        vm.setArrow = function(active, reverse) {
            vm.prodGroupNameArrow = 'fa fa-sort';
            vm.nameArrow = 'fa fa-sort';
            vm.expDateStrArrow = 'fa fa-sort';
            vm.numberOfSubmissionsArrow = 'fa fa-sort';
            switch (active) {
                case ('prodGroupName') :
                    if (reverse) {
                        vm.prodGroupNameArrow = 'fa fa-sort-up';
                    } else {
                        vm.prodGroupNameArrow = 'fa fa-sort-down';
                    }
                    break;
                case ('name') :
                    if (reverse) {
                        vm.nameArrow = 'fa fa-sort-up';
                    } else {
                        vm.nameArrow = 'fa fa-sort-down';
                    }
                    break;
                case ('expDateStr') :
                    if (reverse) {
                        vm.expDateStrArrow = 'fa fa-sort-up';
                    } else {
                        vm.expDateStrArrow = 'fa fa-sort-down';
                    }
                    break;
                case ('numberOfSubmissions') :
                    if (reverse) {
                        vm.numberOfSubmissionsArrow = 'fa fa-sort-up';
                    } else {
                        vm.numberOfSubmissionsArrow = 'fa fa-sort-down';
                    }
                    break;
            }
        };
        init();
    }]);



// WEBPACK FOOTER //
// ./src/controllers/forms.controller.js